import React, { Component } from 'react';
import './App.css';
import Routes from "./Routes";

class App extends Component {
    render() {
        return (
            <div id='app' className="App"> 
                <Routes />
            </div>
        );
    }
}

export default App;
